import { en } from './en';
import { ru } from './ru';
import { Language } from '../services/languageService';

export const translations = {
  en,
  ru,
};

export const getTranslation = (language: Language) => {
  return translations[language] || translations.en;
};

